require('./src/fonts/fonts.css')
const React = require('react')
const { PlatformTheme } = require('./margex-frontend-ui/src/theme')
const ThemeProvider = require('./src/providers/ThemeProvider').default
const ReactQueryProvider = require('./src/providers/ReactQueryProvider').ReactQueryProvider
const ToastProvider = require('./src/providers/ToastProvider').default
const GoogleReCaptchaProvider = require('./src/providers/GoogleReCaptchaProvider').default
const MuiThemeProvider = require('./margex-frontend-ui/src/components/ThemeProvider').ThemeProvider
const Router = require('react-router-dom').BrowserRouter

exports.wrapRootElement = ({ element }) => {
  return (
    <Router>
      <ReactQueryProvider>
        <ThemeProvider>
          <MuiThemeProvider theme={PlatformTheme} mode='light'>
            <GoogleReCaptchaProvider>
              <>
                {element}
                <ToastProvider />
              </>
            </GoogleReCaptchaProvider>
          </MuiThemeProvider>
        </ThemeProvider>
      </ReactQueryProvider>
    </Router>
  )
}

exports.wrapPageElement = require('./src/app/wrapPageElement').wrapPageElement
